import { Text, View } from 'react-native'
import { useQuery } from '@apollo/client'
import { useTranslation } from 'react-i18next'

import { GET_CURRENT_VIP_RECORD } from '@/constants/graphql/queries'
import { convertToDate } from '@/utils/formatter'
import { Vip0, Vip1, Vip2, Vip3, Vip4, Vip5, Vip6, Vip7, Vip8, Vip9, Vip10 } from '@/components/icon'

function VipCard({ hasLabel }: { hasLabel: boolean }) {
  const { t } = useTranslation()
  const { loading, error, data } = useQuery(GET_CURRENT_VIP_RECORD)
  const level = data ? data.getCurrentVipRecord.level : '−'
  const endDate = data ? convertToDate(new Date(data.getCurrentVipRecord.periodEndedTime).valueOf(), false) : '−'
  const badges = [Vip0, Vip1, Vip2, Vip3, Vip4, Vip5, Vip6, Vip7, Vip8, Vip9, Vip10]
  const Badge = data ? badges[level] : () => null
  return (
    <View className={'flex-row items-center justify-between'}>
      <View className={'gap-0.5'}>
        <View className={'flex-row items-center gap-2'}>
          {loading || error ? (
            <>
              <Text className={'font-roboto-black text-[32px] leading-10'}>{'−'}</Text>
            </>
          ) : (
            <>
              <Text className={'font-roboto-black text-[32px] leading-10'}>{t('vip:label')}</Text>
              <Text className={'font-roboto-black text-[32px] leading-10'}>{level.toString()}</Text>
            </>
          )}
          {hasLabel && (
            <View className={'ml-1 rounded bg-success-light px-2 py-0.5'}>
              <Text className={'text-sm text-success'}>{t('ui:currentLevel')}</Text>
            </View>
          )}
        </View>
        <View className={'flex-row gap-1'}>
          <Text className={'text-xs font-medium text-text-tertiary'}>{t('ui:levelValidUntil')}</Text>
          <Text className={'text-xs font-semibold text-info'}>{endDate}</Text>
        </View>
      </View>
      <View className={'h-20'}>
        <Badge />
      </View>
    </View>
  )
}

export default VipCard
